import React, { useContext, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import API from '@aws-amplify/api';
import DeviceContext from '../../context/DeviceContext';
import { parse } from 'date-fns';
import { de } from 'date-fns/locale';

const useStyles = makeStyles((theme) => ({
  // cardContent: {
  //   display: 'flex',
  //   justifyContent: 'space-between',
  //   alignItems: 'center',
  // },
  card: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%'
  },
  cardMargin: { // Nur bei Karten die Standalone sind, also nicht in nem Dropdown auswählbar
    marginTop: theme.spacing(2),
  },
  fileInput: {
    display: 'none', // Hide the file input element
  },
  cardContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'stretch', // Make children elements stretch to fill the width
    flexGrow: 1, // Allows cardContent to expand
  },
  cardActions: {
    justifyContent: 'flex-end',
    paddingRight: theme.spacing(2),
  },
  spacer: { // Dient zusammen mit ner Box/Dic als Füllmaterial über z.B. der CardActions Komponente. In tandem mit min-height aus card Klasse.
    flexGrow: 1, // Fills the space above the date picker
  },
}));

function EmilogLostDataUpload() {

  const classes = useStyles();

  const { currentDevice } = useContext(DeviceContext);

  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState<string>('');
  const [notificationSuccess, setNotificationSuccess] = useState<string>('');

  // Bei der Emilog in der CSV ist ein deutsches Datumsformat und kein ISO oder US Format, daher das deutsche zu Ameriaknisch wechseln

  // function parseGermanDate(dateString: string): Date {
  //   const [datePart, timePart] = dateString.split(', ');
  //   const [day, month, year] = datePart.split('.').map(Number);
  //   const [hours, minutes] = timePart.split(':').map(Number);

  //   return new Date(year, month - 1, day, hours, minutes);
  // }

  // function fixConvertTime(oldData: any) {
  //   const data = structuredClone(oldData);
  //   for (let i = 1; i < data.length; ++i) {
  //     const letztesElement: number = data[i].length - 1;
  //     const date = parseGermanDate(data[i][letztesElement]);
  //     const unixTimestamp = Math.floor(date.getTime() / 1000);
  //     data[i][letztesElement] = unixTimestamp;
  //   }
  //   return data;
  // }

  function fixConvertTime(oldData: any) {
    const data = structuredClone(oldData);

    for (let i = 1; i < data.length; ++i) {
      const letztesElement: number = data[i].length - 1;

      // Beispiel-Format: '04.02.2025, 23:30'
      const dateString = data[i][letztesElement];
      const parsedDate = parse(dateString, 'dd.MM.yyyy, HH:mm', new Date(), { locale: de });

      const unixTimestamp = Math.floor(parsedDate.getTime() / 1000);
      data[i][letztesElement] = unixTimestamp;
    }

    // // 2. Sortieren nach letztem Element (Timestamp)
    // data.sort((a: any[], b: any[]) => {
    //   const timeA = a[a.length - 1];
    //   const timeB = b[b.length - 1];
    //   return timeA - timeB;
    // });

    // // 3. Duplikate entfernen (nach letztem Element / Timestamp)
    // const uniqueData = [data[0]]; // Header behalten
    // const seen = new Set<number>();

    // for (let i = 1; i < data.length; ++i) {
    //   const timestamp = data[i][data[i].length - 1];
    //   if (!seen.has(timestamp)) {
    //     seen.add(timestamp);
    //     uniqueData.push(data[i]);
    //   }
    // }

    // return uniqueData;

    return data;
  }

  function transformCSVData(csvData: string): string[][] {
    // Split the CSV data into rows
    const rows = csvData.split('\n');

    // Remove empty rows
    const nonEmptyRows = rows.filter(row => row.trim() !== '');

    // console.log({ nonEmptyRows });

    // Split each row into columns, handling quotes and trailing special characters
    const rowData = nonEmptyRows
      .map(row => {
        // Replace all double quotes with an empty string
        const cleanedRow = row.replace(/"/g, '');

        // Split the cleaned row into columns
        let columns = cleanedRow.split(';').map(column => column.trim());

        // Remove any trailing special characters like '\r' from each column
        columns = columns.map(column => column.replace(/\r$/, ''));

        // Remove empty strings at the end of the row
        while (columns[columns.length - 1] === '') {
          columns.pop();
        }

        return columns;
      })
      // Filter out any rows that are now completely empty
      .filter(columns => columns.length > 0);

    // console.log({ rowData });

    // CSV file muss noch unterschieden werden. Neues format hat kein CO, wird zu default 0. Header neues Format muss zum alten umgewandelt werden für ide Emicon Tabelle.

    const oldFormatHeader = [
      "Temperatur",
      "O2",
      "Druck",
      "NOx",
      "CO",
      "Zeit"
    ];

    let fixedRowData;

    if (JSON.stringify(rowData[0]) === JSON.stringify(oldFormatHeader)) {
      console.log('Altes Format')
      fixedRowData = fixConvertTime(rowData);
    } else {
      console.log('Format Stimmt nicht überein')
      fixedRowData = [];
    }

    return fixedRowData;
  }

  function parseCSVFile(file: File): Promise<string[][]> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event: any) => {
        try {
          const csv = event.target.result as string;

          const transformedCsc = transformCSVData(csv);
          // Check if CSV data is in the expected format
          if (transformedCsc.length === 0 || transformedCsc[0].length === 0) {
            reject(new Error('CSV Daten sind Leer oder ungültig'));
            setNotification('Datei Format ist nicht gültig'); // Notify user if file is not a CSV
          } else {
            resolve(transformedCsc);
          }
        } catch (error) {
          reject(error);
        }
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsText(file);
    });
  }

  async function handleSubmit(file: File) {
    try {
      setLoading(true);
      // Check if the file is a CSV file
      if (file.type !== 'text/csv') {
        setNotificationSuccess('');
        setNotification('Datei nicht im CSV Format'); // Notify user if file is not a CSV
        setLoading(false);
        return;
      }
      setNotification('');
      setNotificationSuccess('');
      const data = await parseCSVFile(file);

      // console.log(currentDevice.serialNumber)
      // console.log({ data })
      // setLoading(false);
      // return

      // api call mit data und serial number
      const result = await API.post('emilog', 'csvHmwUploadEmilog', {
        body: {
          serialNumber: currentDevice.serialNumber,
          csvDatenArray: data,
        },
      });

      setNotificationSuccess(result.message)
      setTimeout(() => {
        setLoading(false);
      }, 500);
    } catch (err) {
      setLoading(false);
      setNotification('Fehler beim Hochladen der Datei');
      console.error(err);
    }
  }

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event?.target.files?.[0];
    if (!file) return;
    handleSubmit(file);
    event.target.value = '';
  };

  return (
    <Card className={classes.cardMargin}>
      <CardHeader title="CSV Daten Upload" />
      <Divider />
      <CardContent className={classes.cardContent}>
        {notificationSuccess === "" ? (<Typography style={{ fontSize: '16px' }}>Hochladen der HMW Aufzeichnungen der SPS</Typography>) : (null)}
        {notification && <Typography style={{ fontSize: '16px' }} color="error">{notification}</Typography>}
        {notificationSuccess && <Typography style={{ fontSize: '16px', color: "green" }}>{notificationSuccess}</Typography>}
        <Button
          variant="contained"
          color="primary"
          component="label"
          disabled={loading || !currentDevice.serialNumber}
        >
          {'Absenden'}
          <input
            type="file"
            accept=".csv"
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
        </Button>
      </CardContent>
      {loading ? (
        <LinearProgress />
      ) : (
        null
      )}
    </Card>

  );
}

export default EmilogLostDataUpload;
